import "./Banner04.css";

function Banner04() {
  return (
    <div className="Banner04 section">
      <div className="container">
        <div className="Banner04-box">
          <p className="eyebrow ">VIP PACKAGE</p>
          <h2>
            Discover Our New VIP Room Service at{" "}
            <span className="gradient-text">Razor King | Kitchener.</span>
          </h2>
          <p>
            Introducing VIP Room Service. The Ultimate Personal Grooming
            Experience, Only at Razor King - Kitchener.
          </p>
          <a
            href="https://bookings.gettimely.com/razorkingbarbershop1/bb/book"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-3"
          >
            BOOK NOW
          </a>
        </div>
      </div>
    </div>
  );
}

export default Banner04;
